import logo from './AREscape360-logo.png';
import './App.css';
import ContentPanel from './components/content-panel';
function App() {
  return (
    <div className="App">
      <header><img src = {logo} alt = "AREscape360-logo"/></header>
      <div>
      
      </div>
      <div className = "content-panel">
      <h2>Privacy Policy</h2>
        <p>
        We built the AREscape360 app as a Free app. This SERVICE is provided by us at no cost and is intended for use as is.
This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our App.
If you choose to use our App, then you agree to the collection and use of information in relation to this policy. Please note that no Personal Information is collected in any way when you use our App.
The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at AREscape360 unless otherwise defined in this Privacy Policy.
        </p>
        </div>
        
        <div className = "content-panel">
        <h3>Information Collection and Use</h3>
        <p>AREscape360 App requires you to provide Camera permission in order to proceed further. 
        The Camera is active only when the app is being used. 
        The Camera is not used for recording. 
        The Camera does not run in the background. 
        The information that the app requests will be retained on your device and is not collected by us in any way. 
        The app does use third party services that may collect information used to identify you.
        <span>{<br/>}</span>
        Link to privacy policy of third party service providers used by the app: 
        <span>{<br/>}</span>
        <a href ="https://policies.google.com/privacy">Google Play Services</a>
        </p>
        </div>
        

        <ContentPanel
        heading = "Security"
        content = "We value your trust when you use our App. 
        We do not collect your personal information by any means. 
        But remember that no method of transmission over the internet, 
        or method of electronic storage is 100% secure and reliable, 
        and we cannot guarantee its absolute security."
        />

        <ContentPanel
        heading = "Links to Other Sites"
        content = "AREscape360 App does not contain links to other sites. You will not be directed to any site."
        />

        <ContentPanel
        heading = "Children’s Privacy"
        content = "These Services do not address anyone under the age of 13. 
        We do not collect personally identifiable information from children under 13 years of age. 
        In the case We discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. 
        If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to take the necessary actions."
        />

        <ContentPanel
        heading = "Changes to This Privacy Policy"
        content = "We may update our Privacy Policy from time to time. 
        Thus, you are advised to review this page periodically for any changes. 
        We will notify you of any changes by posting the new Privacy Policy on this page. 
        This policy is effective as of 2021-10-07"
        />

        <ContentPanel
        heading = "Contact Us"
        content = "If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at jetxrcreations@gmail.com"
        />
    </div>
  );
}

export default App;
